class FooterNewsletterForm {
  constructor(container) {
    this.container = container;
    this.form = container.querySelector('form');
    if (!this.form) return;
    this.emailInput = this.form.querySelector('input[type="email"]');
    this.submitButton = this.form.querySelector('button[type="submit"]');
    this.errorContainer = this.form.querySelector('.jc-custom-error-tooltip');
    this.originalButtonContent = this.submitButton.innerHTML;
    this.init();
  }
  init() {
    this.form.addEventListener('submit', (e) => {
      e.preventDefault();
      this.handleSubmit();
    });
    this.emailInput.addEventListener('input', () => {
      if (this.errorContainer && this.errorContainer.style.display === 'block') {
        this.errorContainer.style.display = 'none';
      }
    });
  }
  handleSubmit() {
    const emailValue = this.emailInput.value;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    let errorMessage = '';
    if (!emailValue) {
      errorMessage = 'Please enter an email address.';
    } else if (!emailRegex.test(emailValue)) {
      errorMessage = `Please include an '@' in the email address. '${emailValue}' is missing an '@'.`;
    }
    if (errorMessage) {
      this.showError(errorMessage);
      return;
    }
    this.hideError();
    this.setLoading(true);
    fetch('/contact#newsletter', {
      method: 'POST',
      body: new FormData(this.form),
      headers: { 'Accept': 'application/javascript' }
    })
    .then(response => {
      if (response.ok) {
        this.showSuccess();
      } else {
        throw new Error('Subscription failed');
      }
    })
    .catch(error => {
      console.error('Newsletter subscription error:', error);
      this.showError('An unexpected error occurred. Please try again.');
      this.setLoading(false);
    });
  }
  showError(message) {
    if (!this.errorContainer) return;
    this.errorContainer.textContent = message;
    this.errorContainer.style.display = 'block';
  }
  hideError() {
    if (this.errorContainer) {
      this.errorContainer.style.display = 'none';
    }
  }
  setLoading(isLoading) {
    if (isLoading) {
      this.submitButton.setAttribute('disabled', 'disabled');
      this.submitButton.innerHTML = '<div class="m-loader" style="--size: 20px; --color: currentColor;"></div>';
    } else {
      this.submitButton.removeAttribute('disabled');
      this.submitButton.innerHTML = this.originalButtonContent;
    }
  }
  showSuccess() {
    const successMessage = document.createElement('div');
    successMessage.className = 'jc-newsletter-success-message';
    successMessage.textContent = 'Thanks for subscribing!';
    this.form.style.display = 'none';
    this.container.appendChild(successMessage);
  }
}
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.jc-newsletter-form-container').forEach(container => {
    new FooterNewsletterForm(container);
  });
});
